/**
 * Padroniza a grafia da família: BERLIM → BERLIN (em qualquer texto do app).
 * Mantém maiúsculas/minúsculas relativas quando possível.
 */

const CHAVE_MIGRACAO = 'migracao-berlim-berlin-v1';

export function corrigirGrafiaBerlin(texto: string): string {
  return String(texto || '').replace(/\bBERLIM\b/gi, (m) => {
    if (m === m.toUpperCase()) return 'BERLIN';
    if (m[0] === m[0].toUpperCase()) return 'Berlin';
    return 'berlin';
  });
}

export function migracaoBerlimBerlinJaAplicada(): boolean {
  try {
    return localStorage.getItem(CHAVE_MIGRACAO) === '1';
  } catch {
    return false;
  }
}

export function marcarMigracaoBerlimBerlinAplicada(): void {
  try {
    localStorage.setItem(CHAVE_MIGRACAO, '1');
  } catch {
    /* quota */
  }
}

/** Aplica BERLIM→BERLIN em strings de um objeto (campos de nome conhecidos). */
export function corrigirGrafiaBerlinEmRegistro<T extends Record<string, unknown>>(
  obj: T,
  campos: readonly string[]
): T {
  let mudou = false;
  const next = { ...obj };
  for (const campo of campos) {
    const v = next[campo];
    if (typeof v !== 'string' || !/\bBERLIM\b/i.test(v)) continue;
    (next as Record<string, unknown>)[campo] = corrigirGrafiaBerlin(v);
    mudou = true;
  }
  return mudou ? next : obj;
}

function corrigirGrafiaBerlinDeep(valor: unknown): unknown {
  if (typeof valor === 'string') {
    return /\bBERLIM\b/i.test(valor) ? corrigirGrafiaBerlin(valor) : valor;
  }
  if (Array.isArray(valor)) {
    return valor.map(corrigirGrafiaBerlinDeep);
  }
  if (valor && typeof valor === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(valor as Record<string, unknown>)) {
      out[k] = corrigirGrafiaBerlinDeep(v);
    }
    return out;
  }
  return valor;
}

const CHAVES_LS_MIGRAR = [
  'pontuacoes-produtos-ade',
  'lotes-produtos-ade',
  'lotes-produtos',
  'produtos-tempo-corte-ade',
  'produto-palete-config-ade',
  'planos-corte-ade',
  'relatorio-pecas-ade',
  'historico-impressoes-ade',
  'sobra-pecas-ade',
  'auditoria-acoes-ade',
] as const;

/**
 * Uma vez: reescreve chaves do localStorage trocando BERLIM → BERLIN.
 * IndexedDB é corrigido na carga (lotes / tempo de corte / catálogo).
 */
export function aplicarMigracaoBerlimBerlinLocalStorage(): void {
  if (migracaoBerlimBerlinJaAplicada()) return;
  for (const chave of CHAVES_LS_MIGRAR) {
    try {
      const raw = localStorage.getItem(chave);
      if (!raw || !/\bBERLIM\b/i.test(raw)) continue;
      const parsed = JSON.parse(raw);
      const corrigido = corrigirGrafiaBerlinDeep(parsed);
      localStorage.setItem(chave, JSON.stringify(corrigido));
    } catch {
      /* ignora chave inválida */
    }
  }
  marcarMigracaoBerlimBerlinAplicada();
}

export function corrigirListaNomesBerlimBerlin<T>(
  lista: T[],
  campo: keyof T & string
): T[] {
  if (!Array.isArray(lista) || lista.length === 0) return lista;
  let mudou = false;
  const next = lista.map((item) => {
    if (!item || typeof item !== 'object') return item;
    const v = (item as Record<string, unknown>)[campo];
    if (typeof v !== 'string' || !/\bBERLIM\b/i.test(v)) return item;
    mudou = true;
    return { ...item, [campo]: corrigirGrafiaBerlin(v) };
  });
  return mudou ? next : lista;
}
